module.exports = {"title":"Hub Settings","global_settings_title":"Global Settings","datatable":{"global_settings_action":"Global Settings","name":"Name","outlets":"Outlets"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/hub_settings.php
// module id = oVL+
// module chunks = 99